import { FC, ReactNode, useState } from 'react';
import OrganizationLocationContext from './OrganizationLocationContext';
import { useGetCurrentOrganizationLocation } from '@hooks/useGetCurrentOrganizationLocation';
import { useAuth } from '@gemini/fe-utils';

interface OrganizationLocationContextProviderProps {
  children?: ReactNode;
}

const OrganizationLocationContextProvider: FC<
  OrganizationLocationContextProviderProps
> = ({ children }) => {
  const [currentOrganizationLocation, setCurrentOrganizationLocation] =
    useGetCurrentOrganizationLocation();
  const [organizationCoreId, setOrganizationCoreId] = useState<string | null>(
    currentOrganizationLocation.currentOrganizationCoreId
  );
  const [locationCoreId, setLocationCoreId] = useState<string | null>(
    currentOrganizationLocation.currentLocationCoreId
  );
  const [isSwitchingOrganization, setIsSwitchingOrganization] =
    useState<boolean>(false);
  const { switchOrganization, setToken, setRefreshToken, tokenInfo } =
    useAuth();

  return (
    <OrganizationLocationContext.Provider
      value={{
        isSwitchingOrganization,
        organizationCoreId: organizationCoreId,
        locationCoreId,
        setContext: async (
          newOrganizationCoreId,
          organizationAlternateId,
          newLocationCoreId
        ) => {
          setLocationCoreId(newLocationCoreId);
          if (
            newOrganizationCoreId !==
            currentOrganizationLocation.currentOrganizationCoreId
          ) {
            if (newOrganizationCoreId != null) {
              setIsSwitchingOrganization(true);
              const { data, status } = await switchOrganization(
                organizationAlternateId ?? ''
              );
              if (status === 200) {
                setToken(data.access_token);
                setRefreshToken(data.refresh_token);
                setOrganizationCoreId(newOrganizationCoreId);
                setCurrentOrganizationLocation(
                  newOrganizationCoreId,
                  newLocationCoreId
                );
                setIsSwitchingOrganization(false);
              }
            }
          }
        },
      }}
    >
      {children}
    </OrganizationLocationContext.Provider>
  );
};

export default OrganizationLocationContextProvider;
